import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PageBase, OrderCustomerModel, T4InvoiceInfo, T4CCService } from 't4core';
import { Router } from '@angular/router';
import { T4DatatableWidget } from '../../../../../t4common';
import { duration } from 'moment';

@Component({
  styleUrls: ['./Invoices.css'],
  selector: 'Invoices',
  templateUrl: './Invoices.html',
})
export class InvoiceComponent extends PageBase implements OnInit {
  public onlyActive: boolean = true;
  @ViewChild("tblInvoices", { static: false }) tblInvoices: T4DatatableWidget;


  public unsignedPtInvoices: boolean = false;


  constructor(el: ElementRef, private router: Router, private ccService:T4CCService) {
    super(el, "TurboOrder");
  }

  private _from: moment.Moment = this.now.clone().startOf("month");
  private _to: moment.Moment = this.now.clone().endOf("month");
  public queryParameters: any = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };

  public get from(): moment.Moment { return this._from; }
  public set from(val: moment.Moment) {
    if (this._from != val) {
      this._from = val;
      this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };
    }
  }

  public get to(): moment.Moment { return this._to; }
  public set to(val: moment.Moment) {
    if (this._to != val) {
      this._to = val;
      this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };
    }
  }

  public updateParams() {
    this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };
  }

  async ngOnInit() {
    if (this.Settings.isInAny(['BackOffice'])) {
      this.unsignedPtInvoices = await this.Api.get<boolean>("/TurboOrder/AnyUnsignedPTInvoices", {});
    }
  }

  public async resend(invoice: T4InvoiceInfo) {
    if (invoice.SalesId || invoice.IsProcessing) {
      if (!(await this.UI.confirm("T4.CC.Invoices.headConfirmResend", "Confirm resend", "T4.CC.Invoices.msgConfirmResend", "This order is processing or has already been created. Make sure you do not end up with duplicates. Continue?"))) return;
    }

    if (this.ccService.Resend(invoice.Id))
      this.UI.snackBar("The invoice has been resent. Expected import time: ~10 minutes.", null, 10000);
    else
      this.UI.snackBar("The invoice could not be resent!", null, 10000);
  }

  public open(id: string) {
    this.UI.openDialog("T4.Order.InvoiceDialog", { data: { invoiceId: id } });
  }

  public async signPTInvoices() {
    if (!(await this.UI.confirm("T4.CC.Invoices.headConfirmSignPT", "Confirm signature", "T4.CC.Invoices.msgConfirmSignPT", "Have you made sure that the amount is correct?! If you fail this, its both yours and Björns asses..."))) return;

    await this.Api.get<boolean>("/TurboOrder/SignPayThroughInvoices", {});
    this.unsignedPtInvoices = await this.Api.get<boolean>("/TurboOrder/AnyUnsignedPTInvoices", {});
  }
}
